import { useRef, useEffect } from "react";
import _ from "lodash";

/**
 * @param selector -> string will use _.find,
 */
const useOptionEnsure = (options, form, key, selector) => {
    const ref = useRef(null);
    ref.current = {form, key, selector};

    useEffect(() => {
        const {form, key, selector} = ref.current;
        if(options && options.length > 0) {
            if(!form.formState[key] || (_.isArray(form.formState[key]) && form.formState[key].length === 0)) { //form field is empty
                let option = selector ? _.find(options, selector) : options[0];
                form.handleFormChange(option, {name: key})
            } else if(!_.isArray(form.formState[key]) && !_.find(options, {value: form.formState[key]?.value})) {  //form field has single value that isnt in options
                let option = selector ? _.find(options, selector) : options[0];
                form.handleFormChange(option, {name: key})
            }
        } else if (form.formState[key]) { //form field has value but there are no options
            form.handleFormChange(null, {name: key})
        }
    }, [options])
}

export default useOptionEnsure;
